var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar',[_c('h2',[_c('i',{staticClass:"fa",class:_vm.icon}),_vm._v("\n\t\t"+_vm._s(_vm.heading)+"\n\t")]),_c('div',{staticClass:"controls"},[_c('nav-tabs',{attrs:{"tabs":_vm.tabs,"mobile-breakpoint":"1024","addon-apps-location":"Health & Safety Module","addon-apps-link":"/safety/apps"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }